export const shouldReportLogToDatadog = (log: string) => {
  const messageLogLowerCase = log.toLowerCase()

  if (messageLogLowerCase.includes('fbnavlargestcontentfulpaint')) return false

  if (messageLogLowerCase.includes('fbnavfirstcontentfulpaint')) return false

  if (messageLogLowerCase.includes('fbnavdomcontentloaded')) return false

  if (messageLogLowerCase.includes('fbnavampdetect:false')) return false

  if (messageLogLowerCase.includes('fbnavresponseend')) return false

  if (messageLogLowerCase.includes('fbnavloadeventend')) return false

  if (messageLogLowerCase.includes('annavresponseend')) return false

  if (messageLogLowerCase.includes('annavdomcontentloaded')) return false

  if (messageLogLowerCase.includes('annavloadeventend')) return false

  if (messageLogLowerCase.includes('uncaught "script error."')) return false

  // eslint-disable-next-line max-len
  if (messageLogLowerCase.includes('ignoredeventcancel: intervention: ignored attempt to cancel a touchend event with cancelable=false')) {
    return false
  }

  if (messageLogLowerCase === 'failed to fetch') return false

  if (messageLogLowerCase.includes('error sending segment performance metrics')) return false

  if (messageLogLowerCase.includes('fetch error')) {
    if (messageLogLowerCase.includes('post')) {
      if (messageLogLowerCase.includes('https://api-sgm.asaas.com')) return false

      if (messageLogLowerCase.includes('https://boto.asaas.com/app/savevariantchoice')) return false

      if (messageLogLowerCase.includes('https://analytics.google.com/g/collect')) return false

      if (messageLogLowerCase.includes('https://www.google.com/measurement/conversion')) return false

      if (messageLogLowerCase.includes('https://ad.doubleclick.net/activity')) return false

      if (messageLogLowerCase.includes('https://signal.asaas.com/com.segment/v1/')) return false
    }

    if (messageLogLowerCase.includes('get')) {
      if (messageLogLowerCase.includes('https://cdn-boto.asaas.com')) return false

      if (messageLogLowerCase.includes('https://cdn-sgm.asaas.com')) return false

      if (messageLogLowerCase.includes('https://www.asaas.com/?_rsc')) return false

      if (messageLogLowerCase.includes('https://www.asaas.com.br/?_rsc')) return false

      if (messageLogLowerCase.includes('https://measurement-api.criteo.com')) return false

      if (messageLogLowerCase.includes('https://www.googleadservices.com')) return false
    }
  }

  if (messageLogLowerCase.includes('xhr error')) {
    if (messageLogLowerCase.includes('https://px.ads.linkedin.com')) return false

    if (messageLogLowerCase.includes('post')) {
      if (messageLogLowerCase.includes('https://stats.g.doubleclick.net')) return false

      if (messageLogLowerCase.includes('https://www.google-analytics.com')) return false

      if (messageLogLowerCase.includes('https://bat.bing.com')) return false

      if (messageLogLowerCase.includes('https://bat.bing-int.com')) return false

      if (messageLogLowerCase.includes('https://m.clarity.ms/collect')) return false

      if (messageLogLowerCase.includes('https://overbridgenet.com/jsv8/offer')) return false
    }

    if (messageLogLowerCase.includes('get')) {
      if (messageLogLowerCase.includes('https://vc.hotjar.io')) return false
    }
  }

  if (messageLogLowerCase.includes('uncaught "object not found matching')) return false

  if (isIgnoredChunkLoadError(log)) return false

  if (messageLogLowerCase.includes('invalid call to runtime.sendmessage()')) return false

  return true
}

/* eslint-disable enforce-numeric-separator/enforce-numeric-separator */
const ERROR_LOADING_CLARITY_CHUNK = 3327
const ERROR_LOADING_CLARITY_CHUNK_2 = 1783
/* eslint-enable enforce-numeric-separator/enforce-numeric-separator */

const IGNORED_CHUNKS = [ERROR_LOADING_CLARITY_CHUNK, ERROR_LOADING_CLARITY_CHUNK_2]

const isIgnoredChunkLoadError = (log: string, chunks: number[] = IGNORED_CHUNKS): boolean => {
  const lowerLog = log.toLowerCase()
  return chunks.some(chunk =>
    lowerLog.includes(`loading chunk ${chunk} failed.`)
  )
}
